import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import CenteredColumns from "./CenteredColumns";
import { Link } from "./../util/router";
import "./ContentCardsSection.scss";

function ContentCardsSection(props) {
  const items = [
    {
      image:
        "blockchain_icon.svg",
      title: "Blockchain Layer",
      body: "Our Żetonium blockchain is Ethereum-forked and interoperable with Flow, Polygon and Ethereum 2.0 PoS mainnet.",
    },
    {
      image:
        "smart_license.svg",
      title: "Smart Licenses",
      body: "We use an assembly of smart licenses and associated contracts linked to registered files. These licenses record and enforce usage and distribution terms for data assets.",
    },
    {
      image:
        "exchange_icon.svg",
      title: "Exchange Layer",
      body: "Accounts use the bid/ask-based DASE exchange layer to create and sign a variety of generic and custom smart licenses built by PDS platform developers to enable comprehensive data access control.",
    },
    {
      image:
        "api_icon1.svg",
      title: "Developer Platform",
      body: "Use our REST API toolkit to integrate new and existing applications with PDS. We also provide client libraries for popular languages.",
    },
    {
      image:
        "vault.svg",
      title: "Vaults for Cloud storage/CDN data",
      body: "Gatekeep access to data in cloud storage using PDS API encrypted blockchain transactions and smart licenses.",
    },
    {
      image:
        "stable_currency.svg",
      title: "Internal Credit System",
      body: "Our platform's credit/transaction system uses an internal cryptocurrency called a Żeton as its unit of accounting. One Żeton is equivalent in value to a US dollar and used to settle asset transactions on the licenses exchange. Our API supports direct balance transfers and providing funding from one account to another via line of credit.",
    },
    {
      image:
        "Interoperable_with.svg",
      title: "Interoperable with other blockchain networks",
      body: "Use the PDS API to transfer SAT tokens from Żetonium (ERC-721 compatible) as pNFTs onto Ethereum, Polygon and Flow. Import external NFTs from these networks onto Żetonium as SATs with licensing and royalties capabilities.",
    },
  ];

  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <CenteredColumns>
          {items.map((item, index) => (
            <div
              className="column is-half-tablet is-one-third-desktop"
              key={index}
            >
              <Link
                to={item.url}
                className="ContentCardsSection__card card is-flex"
              >
                <div className="card-image">
                  <figure className="image is-4by3">
                    <img src={item.image} alt={item.title} />
                  </figure>
                </div>
                <div className="card-content">
                  <div className="content">
                    <h4>{item.title}</h4>
                    <p>{item.body}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </CenteredColumns>
      </div>
    </Section>
  );
}

export default ContentCardsSection;
